export { EducationNew } from "./EducationNew";
